import type { FC, ReactNode } from 'react'

import Image from 'next/image'
import { cn } from '@/lib/utils'

interface ImgProps {
    src: string | null | undefined
    alt: string
    sizes?: string
    preload?: boolean
    grayscale?: boolean
    className?: string
}

/**
 * A responsive image that fills its (positioned) parent. Photography is shown in full
 * color; pass grayscale to render a single image in black and white.
 */
const Img: FC<ImgProps> = ({
    src,
    alt,
    sizes = '100vw',
    preload = false,
    grayscale = false,
    className
}): ReactNode => {
    if (!src) return <div aria-hidden='true' className='absolute inset-0 bg-coal' />

    return (
        <Image
            src={src}
            alt={alt}
            fill
            sizes={sizes}
            preload={preload}
            quality={92}
            draggable={false}
            className={cn('object-cover', grayscale && 'grayscale', className)}
        />
    )
}

export default Img
